import { render, staticRenderFns } from "./im-message.vue?vue&type=template&id=6f57b0f2&scoped=true"
import script from "./im-message.vue?vue&type=script&lang=js"
export * from "./im-message.vue?vue&type=script&lang=js"
import style0 from "./im-message.vue?vue&type=style&index=0&id=6f57b0f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f57b0f2",
  null
  
)

export default component.exports